import moment from "moment";

export default {
    methods: {
        formatPeriodTitle (period) {
            return period ? moment(period).format('MMMM YYYY') : ''
        },
        formatInvoiceObject (item) {
            let infoObj = {
                id: item.id || null,
                status: item.status || '',
                isPaid: item.paid || false,
                isFinalised: item.is_finalized || false,
                label: item.description || null,
                total: typeof item.amount === "number" && item.currency ? this.getCurrencySign(item.currency) + this.formatToDollars(item.amount) : null,
                invoiceNumber: item.invoice_number || null,
                invoicePdf: item.invoice_pdf || null,
                checkoutUrl: item.hosted_invoice_url || null,
                paymentDueDate: item.payment_due_date ? moment(item.payment_due_date).format('MM-DD-YYYY') : null,
                resource: item.resource ? {
                    id: item.resource.id || '',
                    title: item.resource.title || '',
                    key: item.resource.key || ''
                } : null,
                period: this.formatPeriodTitle(item.calendar_period) || ''
            };

            if (Array.isArray(item.line_items)) {
                infoObj.items = item.line_items.map((item) => {
                    return {
                        items: [{
                            label: item.description,
                            price: typeof item.amount === "number" && item.currency ? this.getCurrencySign(item.currency) + this.formatToDollars(item.amount) : null,
                        }]
                    }
                })
            }

            return infoObj;
        }
    }
}